// InspireOverlay.tsx — "Inspire me, with the words of others". A reliable,
// on-demand way to read a random testimonial from a past programme user (the old
// in-feed testimonial tile only surfaced at rare boundaries). Opened from the
// header / side-nav. Re-roll for another; tap outside or the close button to leave.
import React from 'react';
import TESTIMONIALS from '@/data/testimonials.generated.json';
import { Btn } from '@/components/ui';
import { Icon } from '@/components/icons';

function pick(excludeId?: string): { id: string; quote: string } {
  const pool = TESTIMONIALS.filter((t) => t.id !== excludeId);
  const list = pool.length ? pool : TESTIMONIALS;
  return list[Math.floor(Math.random() * list.length)];
}

export function InspireOverlay({ onClose }: { onClose: () => void }) {
  const [t, setT] = React.useState(() => pick());
  return (
    <div
      onClick={onClose}
      style={{
        position: 'absolute',
        inset: 0,
        zIndex: 116,
        background: 'rgba(40,30,12,0.42)',
        backdropFilter: 'blur(3px)',
        WebkitBackdropFilter: 'blur(3px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'calc(var(--safe-top) + 24px) 26px calc(var(--safe-bottom) + 24px)',
        animation: 'fade .25s ease',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: 'relative',
          width: '100%',
          maxWidth: 384,
          background: 'linear-gradient(178deg, var(--card-top), var(--card-bot))',
          border: '1px solid var(--hair)',
          borderRadius: 'var(--r-card)',
          boxShadow: 'var(--shf)',
          padding: '30px 24px 24px',
          textAlign: 'center',
        }}
      >
        <button
          onClick={onClose}
          aria-label="Close"
          style={{ position: 'absolute', top: 8, right: 8, background: 'none', border: 'none', color: 'var(--ink-soft)', minWidth: 44, minHeight: 44, cursor: 'pointer' }}
        >
          <Icon name="chevDown" size={20} />
        </button>
        <div
          style={{
            fontFamily: 'Inter, system-ui, sans-serif',
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: '0.13em',
            textTransform: 'uppercase',
            color: 'var(--amber-deep)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 6,
          }}
        >
          <Icon name="sparkle" size={13} /> In the words of others
        </div>
        <blockquote
          style={{
            margin: '14px 0 22px',
            padding: 0,
            fontFamily: 'Fraunces, Georgia, serif',
            fontStyle: 'italic',
            fontWeight: 400,
            fontSize: 20,
            lineHeight: 1.5,
            color: 'var(--green-deep)',
          }}
        >
          “{t.quote}”
        </blockquote>
        <Btn full onClick={() => setT((cur) => pick(cur.id))} leading={<Icon name="sparkle" size={17} />}>
          Inspire me again
        </Btn>
      </div>
    </div>
  );
}
